import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { useProfileContext } from '../../context/profile'
import { LoadingContainer } from './styles/RequireAdminStyles'

interface RequireAdminProps {
  children: React.ReactNode
}

/**
 * Route guard that only allows admin and super_admin users
 */
export function RequireAdmin({ children }: RequireAdminProps) {
  const { profile, loading } = useProfileContext()

  if (loading) {
    return (
      <LoadingContainer>
        <Spin size="large" />
      </LoadingContainer>
    )
  }

  if (!profile) {
    return <Navigate to="/login" />
  }

  if (profile.role !== 'admin' && profile.role !== 'super_admin') {
    return <Navigate to="/" />
  }

  return <>{children}</>
}
